/*************************************************************************
 *
 * c20g CONFIDENTIAL
 * __________________
 *
 *  [2007] - [2019] Counterpoint Consulting, Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Counterpoint Consulting Incorporated.
 * The intellectual and technical concepts contained
 * herein are proprietary to Counterpoint Consulting Incorporated
 * and its suppliers and may be covered by U.S. and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Counterpoint Consulting Incorporated.
 */

var PageableCollection = require('psa-backbone/models/PageableCollection');
var GridView = require('psa-marionette/views/GridView');

var GetAssignedTasks = require('../services/GetAssignedTasks');

module.exports = {
  channel: 'sc:internal-dashboard',

  event: 'build:assigned-tasks-grid-view',

  builder: function(gridColumns) {
    var deferred = $.Deferred();

    GetAssignedTasks()
      .done(function(assignedTasks) {
        deferred.resolve(
          new GridView({
            columns: gridColumns,
            collection: new PageableCollection(assignedTasks, { pageSize: 10 }),
            emptyText: 'No Tasks Assigned.'
          })
        );
      })
      .fail(function(err) {
        deferred.reject(err);
      });

    return deferred.promise();
  }
};
